import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { currencyConversionRatesImportColDefs } from '../../shared/columnDefinitions/currencyConversionRates';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';

export default ({
  missingRates,
  periodName,
  environmentSuffix,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}) => {
  xlsxExport({
    sheetData: [
      {
        name: 'Missing Rates',
        columnDefinitions: currencyConversionRatesImportColDefs,
        data: missingRates,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
    ],
    metadata: {
      disableHeaderRendering: true,
      fileName: `Missing_Rates_${periodName}${environmentSuffix}`,
    },
  });
};
